import {
  BRAND_PAGE_DETAILS,
  OVERVIEW_PAGE_DETAILS,
  PRODUCTS_PAGE_DETAILS,
  PageDetails,
  PageType,
  RETAILER_OPPORTUNITY_REVIEW_PAGE_DETAILS,
  RETAILER_PERFORMANCE_ANALYSIS_PAGE_DETAILS,
  RETAILER_PRODUCT_ANALYZER_PAGE_DETAILS,
  SEGMENTATION_PAGE_DETAILS,
  SlidesByType,
} from '../common';

export const EmptyPageDetails: PageDetails = { selectors: [] };

export const getPageDetails = (pageType?: PageType, type?: SlidesByType): PageDetails => {
  let details = EmptyPageDetails;

  if (type === SlidesByType.CONSUMER_LOST_SHOPPER) {
    switch (pageType) {
      case PageType.BRAND:
        details = BRAND_PAGE_DETAILS;
        break;
      case PageType.OVERVIEW:
        details = OVERVIEW_PAGE_DETAILS;
        break;
      case PageType.PRODUCTS:
        details = PRODUCTS_PAGE_DETAILS;
        break;
      case PageType.SEGMENTATION:
        details = SEGMENTATION_PAGE_DETAILS;
        break;
      case PageType.OPPORTUNITY_REVIEW:
        details = RETAILER_OPPORTUNITY_REVIEW_PAGE_DETAILS;
        break;
      case PageType.PERFORMANCE_ANALYSIS:
        details = RETAILER_PERFORMANCE_ANALYSIS_PAGE_DETAILS;
        break;
      default:
        break;
    }
  } else if (type === SlidesByType.CONSUMER_RETAIL_LOST_SHOPPER) {
    switch (pageType) {
      case PageType.OPPORTUNITY_REVIEW:
        details = RETAILER_OPPORTUNITY_REVIEW_PAGE_DETAILS;
        break;
      case PageType.PERFORMANCE_ANALYSIS:
        details = RETAILER_PERFORMANCE_ANALYSIS_PAGE_DETAILS;
        break;
      case PageType.PRODUCT_ANALYZER:
        details = RETAILER_PRODUCT_ANALYZER_PAGE_DETAILS;
        break;
      default:
        break;
    }
  }

  return details;
};
